const VisibilityMode = () => {
    return (
        <>
            <h1 className='visibility-heading'>For better experience, view on desktop</h1>
        </>
    )
}

export default VisibilityMode;